<script setup lang="ts"></script>

<template>
  <div class="pa-4 text-caption text-center">
    <i18n-t keypath="vue.legal-conditions.text">
      <template #terms>
        <a
          href="https://www.starmind.ai/terms-user"
          target="_blank"
          class="text-primary"
          >{{ $t('legal-conditions.link.user-terms.label') }}</a
        >
      </template>
      <template #privacy>
        <a
          href="https://www.starmind.ai/privacy-policy"
          target="_blank"
          class="text-primary"
          >{{ $t('legal-conditions.link.privacy-policy.label') }}</a
        >
      </template>
    </i18n-t>
  </div>
</template>
